var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import * as format from 'date-fns/format';
import * as addDays from 'date-fns/add_days';
import * as isWithinRange from 'date-fns/is_within_range';
var RootDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  background-color: #eee;\n  padding: 20px;\n\n  ", "\n\n  > a {\n    text-decoration: none;\n    color: inherit;\n\n    > .title {\n      width: 100%;\n      height: 140px;\n      line-height: 30px;\n      font-size: 16px;\n    }\n\n    > .createdAt {\n      width: 100%;\n      height: 20px;\n      text-align: right;\n    }\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n  background-color: #eee;\n  padding: 20px;\n\n  ",
    "\n\n  > a {\n    text-decoration: none;\n    color: inherit;\n\n    > .title {\n      width: 100%;\n      height: 140px;\n      line-height: 30px;\n      font-size: 16px;\n    }\n\n    > .createdAt {\n      width: 100%;\n      height: 20px;\n      text-align: right;\n    }\n  }\n"])), function (_a) {
    var notice = _a.notice;
    var endDate = new Date();
    var startDate = addDays(endDate, -7);
    var createdAt = Number(notice.createdAt);
    return isWithinRange(createdAt, startDate, endDate) && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: #008e85;\n      color: #fff;\n    "], ["\n      background-color: #008e85;\n      color: #fff;\n    "])));
});
var Notice = function (props) {
    var notice = props.notice, project = props.project;
    var title = notice.title;
    var createdAt = Number(notice.createdAt);
    return (React.createElement(RootDiv, __assign({}, props),
        React.createElement(Link, { to: "/" + project + "/customer/" + notice.parent.urlName + "/" + notice.numberInBoard },
            React.createElement("div", { className: "title" }, title),
            React.createElement("div", { className: "createdAt" }, format(createdAt, 'YY-MM-DD')))));
};
export default Notice;
var templateObject_1, templateObject_2;
